import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import Distribution from "./pages/Distribution";
import Sales from "./pages/Sales";
import Marketing from "./pages/Marketing";
import Films from "./pages/Films";
import FilmDetail from "./pages/FilmDetail";
import OlderGods from "./pages/OlderGods";
import Patriarch from "./pages/Patriarch";
import Contact from "./pages/Contact";
import SubmitFilm from "./pages/SubmitFilm";
import FAQ from "./pages/FAQ";

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-neutral-950 min-h-screen">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/distribution" element={<Distribution />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/films" element={<Films />} />
              <Route path="/films/older-gods" element={<OlderGods />} />
              <Route path="/films/patriarch" element={<Patriarch />} />
              <Route path="/films/:id" element={<FilmDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/submit" element={<SubmitFilm />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        {/* Film Grain Overlay */}
        <div className="grain-overlay" />
      </div>
    </HelmetProvider>
  );
}

export default App;
